var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-summary-block",
      class: [
        _vm.setClassSummary(_vm.data.type),
        _vm.extendClass,
        { mobile: _vm.isMobile }
      ],
      style: _vm.setStyleSummary(_vm.masterData, _vm.data.color)
    },
    [
      _c("div", { staticClass: "item-name" }, [_vm._v(_vm._s(_vm.data.name))]),
      _vm._v(" "),
      !_vm.isMobile
        ? _c("div", { staticClass: "item-count" }, [_vm._v("\n    0\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "edit-or-delete" }, [
        _c("div", { staticClass: "button" }, [
          _c(
            "div",
            {
              staticClass: "edit",
              on: {
                click: function($event) {
                  _vm.openModal(_vm.data, _vm.index)
                }
              }
            },
            [_c("i", { staticClass: "fa fa-pencil-square-o" })]
          ),
          _vm._v(" "),
          !_vm.isDefault(_vm.data.key)
            ? _c(
                "div",
                {
                  staticClass: "delete",
                  on: {
                    click: function($event) {
                      _vm.confirmDeleteSummaryBlock(_vm.index)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-trash" })]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b56c914", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b56c914","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/jSummaryWorkflow.vue
// module id = null
// module chunks = 